import React, { useEffect, useState } from "react";
import { FaCamera, FaSpinner, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

import Post from "../../components/timeLine/post";
import useAuth from "../../hooks/useAuthContext";
import useApp from "../../hooks/useAppContext";
import api from "../../services/axios";

import "../adm/admPatrocinadoresList.css";
import "./home.css";

const Home = () => {
  const { usuario } = useAuth();
  const { handleImagemParticipante } = useApp();
  const [postagens, setPostagens] = useState([]);
  const [textoPostagem, setTextoPostagem] = useState("");
  const [imagemPostagem, setImagemPostagem] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingFeed, setLoadingFeed] = useState(true);

  const notifyInfo = (mensagem) =>
    toast.info(mensagem, { theme: "colored", autoClose: 3000 });
  const notifyError = (mensagem) => toast.error(mensagem, { theme: "colored" });

  useEffect(() => {
    carregarPostagens();
  }, []);

  const carregarPostagens = async ({ silent = false } = {}) => {
    try {
      if (!silent) setLoadingFeed(true);
      const respPostagens = await api.post(`/postagens`, {});
      if (respPostagens.status === 200) {
        setPostagens(respPostagens.data.dados || []);
      }
    } finally {
      if (!silent) setLoadingFeed(false);
    }
  };

  const handleChangeImage = (e) => {
    if (e.target.files.length) {
      setPreview(URL.createObjectURL(e.target.files[0]));
      setImagemPostagem(e.target.files[0]);
    }
  };

  const handlePostagem = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("descricao", textoPostagem);
      if (imagemPostagem) {
        formData.append("foto", imagemPostagem);
      }

      const response = await api.post(`/postagens-create`, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        notifyInfo(response.data.mensagem);
        limparFormulario();
        await carregarPostagens({ silent: true });
      }
    } catch (error) {
      notifyError(
        error.response.data.mensagem + "\n" + error.response.data.erro
      );
    } finally {
      setLoading(false);
    }
  };

  const limparFormulario = () => {
    setTextoPostagem("");
    setImagemPostagem(null);
    setPreview(null);
  };

  const removerImagem = () => {
    setImagemPostagem(null);
    setPreview(null);
    const input = document.getElementById("input-camera");
    if (input) input.value = "";
  };

  return (
    <div className="main">
      <div className="corpo-pagina home-page">
        <div className="apl-page">
          <div className="body-tela-adm">
            <section
              className={`apl-card home-composer${
                loading ? " home-composer--loading" : ""
              }`}
              aria-label="Nova publicação"
            >
              {loading ? (
                <div className="apl-loading home-composer-loading">
                  <FaSpinner className="fa-spin" size={28} aria-hidden />
                  <span>Publicando…</span>
                </div>
              ) : null}

              <div className="home-composer-row">
                <img
                  src={handleImagemParticipante(usuario)}
                  alt=""
                  className="home-avatar"
                />
                <input
                  type="text"
                  className="home-composer-input"
                  value={textoPostagem}
                  onChange={(e) => setTextoPostagem(e.target.value)}
                  placeholder="O que está pensando?"
                  disabled={loading}
                  aria-label="Texto da publicação"
                />
              </div>

              {preview ? (
                <div className="home-preview">
                  <span className="home-preview-label">Preview da imagem</span>
                  <div className="home-preview-container">
                    <img src={preview} alt="Preview da imagem" />
                    <button
                      type="button"
                      className="home-preview-remove"
                      onClick={removerImagem}
                      title="Remover imagem"
                      aria-label="Remover imagem"
                      disabled={loading}
                    >
                      <FaTimes />
                    </button>
                  </div>
                </div>
              ) : null}

              <div className="home-composer-actions">
                <label
                  htmlFor="input-camera"
                  className={`apl-btn apl-btn--secondary home-btn-camera${
                    loading ? " is-disabled" : ""
                  }`}
                >
                  <FaCamera aria-hidden />
                  Foto
                </label>
                <input
                  type="file"
                  id="input-camera"
                  accept="image/*"
                  onChange={handleChangeImage}
                  disabled={loading}
                />
                <button
                  type="button"
                  disabled={loading}
                  className="apl-btn apl-btn--primary"
                  onClick={handlePostagem}
                >
                  Enviar
                </button>
              </div>
            </section>

            <section
              className="apl-card home-feed-card"
              aria-label="Lista de publicações"
            >
              {loadingFeed ? (
                <div className="apl-loading">
                  <FaSpinner className="fa-spin" size={28} aria-hidden />
                  <span>Carregando publicações…</span>
                </div>
              ) : postagens.length === 0 ? (
                <div className="apl-empty">
                  <p className="apl-empty-title">Nenhuma publicação ainda</p>
                  <p style={{ margin: 0 }}>
                    Seja o primeiro a compartilhar algo na timeline.
                  </p>
                </div>
              ) : (
                <div className="home-feed" id="listagem-timeline">
                  {postagens.map((post) => (
                    <Post
                      key={post.id}
                      imagem={post.foto}
                      usuario={post.usuario}
                      avatar={handleImagemParticipante(post.usuario)}
                      descricao={post.descricao}
                      post={post}
                      handlePostagem={() => carregarPostagens({ silent: true })}
                    />
                  ))}
                </div>
              )}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
